module.exports = __webpack_public_path__ + "static/gt-haptik-medium-rotalic-500.latin-9081b16c4b4680ebe0a18d1536623e9e.woff2";